import { render, staticRenderFns } from "./preloaderBlock.vue?vue&type=template&id=229f542a&scoped=true"
var script = {}
import style0 from "./preloaderBlock.vue?vue&type=style&index=0&id=229f542a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f542a",
  null
  
)

export default component.exports